const SvgBg = ({ children }) => {
  return (
    <div style={{ position: "relative", width: "100%", height: "560px" }}>
      <svg style={{ position: "absolute", top: '40vh', left: 0, zIndex: 0 }} xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="560" preserveAspectRatio="none" viewBox="0 0 1440 560">
        <g mask="url(#SvgjsMask1060)" fill="none">
          <path
            d="M -441.90340781785375,198 C -345.9,249.2 -153.9,440.6 38.09659218214627,454 C 230.1,467.4 326.1,264.2 518.0965921821463,265 C 710.1,265.8 806.1,472 998.0965921821463,458 C 1190.1,444 1389.72,216.4 1478.0965921821462,195 C 1566.48,173.6 1447.62,319.8 1440,351"
            stroke="rgba(21, 200, 173, 0.58)"
            strokeWidth="2"
          />
          <path
            d="M -645.4396708687552,249 C -549.44,270.4 -357.44,352.4 -165.4396708687553,356 C 26.56,359.6 122.56,271.8 314.5603291312447,267 C 506.56,262.2 602.56,358.4 794.5603291312448,332 C 986.56,305.6 1145.47,132 1274.5603291312448,135 C 1403.65,138 1406.91,304.6 1440,347"
            stroke="rgba(21, 200, 173, 0.58)"
            strokeWidth="2"
          />
          <path
            d="M -605.1514814404267,238 C -509.15,287.2 -317.15,514.2 -125.15148144042666,484 C 66.85,453.8 162.85,99.4 354.84851855957334,87 C 546.85,74.6 642.85,399.4 834.8485185595733,422 C 1026.85,444.6 1193.82,216.4 1314.8485185595732,200 C 1435.88,183.6 1414.97,312 1440,340"
            stroke="rgba(21, 200, 173, 0.58)"
            strokeWidth="2"
          />
        </g>
        <defs>
          <mask id="SvgjsMask1060">
            <rect width="1440" height="560" fill="#ffffff" />
          </mask>
        </defs>
      </svg>
      <div style={{ position: "relative", zIndex: 1 }}>{children}</div>
    </div>
  );
};

export default SvgBg;
